<template>
  <div>
    <h1>Boxes</h1>
    <v-data-table
      :pagination.sync="pagination"
      :total-items="boxCount"
      :loading="loading"
      :headers="headers"
      :items="modifiedBoxes"
      :footer-props="{ showFirstLastPage, showCurrentPage }"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn :to="{ name: 'box', params: { id: props.item.id } }">{{
              props.item.id
            }}</v-btn>
          </td>
          <td>
            <EntityZ
              :entity="props.item.user"
              format="system"
              v-if="props.item.user"
            />
            <span v-if="!props.item.user">{{ props.item.userid }}</span>
          </td>
          <td>{{ props.item.timestamp | formatDate }}</td>
          <td>
            <EntityZ
              :entity="props.item.finished"
              format="system"
              v-if="props.item.finished"
            />
            <span v-if="!props.item.finished">{{ props.item.finishedid }}</span>
          </td>
          <td>{{ props.item.finishedon | formatDate }}</td>
          <td>
            <span v-if="props.item.files">{{ props.item.files.length }}</span>
            <span v-if="!props.item.files">No files</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import { vectorNotBlank, convertListOfObjectsToMap } from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Boxes",
  metaInfo() {
    return {
      title: "Boxes",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  components: { EntityZ },
  computed: {
    modifiedBoxes() {
      if (!this.boxes) {
        return undefined;
      }
      const entitiesMap = this.entities
        ? convertListOfObjectsToMap(this.entities, "id")
        : undefined;
      return this.boxes.map((b) => {
        const files = this.files ? this.files[b.id] : undefined;
        const finished = entitiesMap ? entitiesMap[b.finishedid] : undefined;
        const user = entitiesMap ? entitiesMap[b.userid] : undefined;
        return { ...b, files, finished, user };
      });
    },
  },
  data() {
    return {
      boxCount: 0,
      boxes: [],
      entities: null,
      files: null,
      headers: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Created by",
          value: "userid",
        },
        {
          text: "Created on",
          value: "timestamp",
        },
        {
          text: "Finished by",
          value: "finishedid",
        },
        {
          text: "Finished on",
          value: "finishedon",
        },
        {
          text: "N files",
          value: "files",
        },
      ],
      filters: {
        id: null,
        timestamp: null,
        finishedon: null,
        finishedid: null,
        userid: null,
      },
      loading: false,
      pagination: {
        sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
      showFirstLastPage: true,
      showCurrentPage: true,
    };
  },
  methods: {
    async fetchBoxCount() {
      const response = await nbmlaw.post(
        `/cors/admin/file/boxes/search/count`,
        this.filters
      );
      // console.log(response.data)
      this.boxCount = response.data;
    },
    async fetchBoxes() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      let firstRow = (page - 1) * rowsPerPage;
      this.filters.sortBy = sortBy;
      this.filters.descending = descending;
      const response = await nbmlaw.post(
        `/cors/admin/file/boxes/search/${firstRow}/${rowsPerPage}`,
        this.filters
      );
      // console.log(response.data)
      this.boxes = response.data;
      this.fetchEntities();
      this.fetchBoxesFiles();
      this.loading = false;
    },
    fetchEntities() {
      const ids = [
        ...new Set([...vectorNotBlank(this.boxes, "userid")]),
        ...new Set([...vectorNotBlank(this.boxes, "finishedid")]),
      ];
      // console.log("User length: " + userids);
      if (ids.length > 0) {
        const ids_ = ids.join(".");
        nbmlaw
          .get(`/cors/admin/directory/entities/multiple/${ids_}`)
          .then((response) => {
            // console.log(response.data);
            this.entities = response.data;
          })
          .catch(() => {});
      }
    },
    fetchBoxesFiles() {
      const ids = [...new Set([...vectorNotBlank(this.boxes, "id")])];
      // console.log("User length: " + userids);
      if (ids.length > 0) {
        const ids_ = ids.join(".");
        nbmlaw
          .get(`/cors/admin/file/boxes/multiple/${ids_}/files`)
          .then((response) => {
            // console.log(response.data);
            this.files = response.data;
          })
          .catch(() => {});
      }
    },
    update() {
      this.loading = true;
      this.fetchBoxCount();
      this.fetchBoxes();
    },
    search() {
      this.pagination.page = 1;
      this.update();
    },
  },
  watch: {
    pagination: {
      handler() {
        this.update();
      },
      deep: true,
    },
  },
  created() {
    this.update();
  },
};
</script>

